module.exports = __webpack_public_path__ + "img/002-woman.ca02df6a.svg";